import { gql } from "@apollo/client";

export const PROSPECTO_FRAGMENT = gql`
  fragment ProspectoFragment on Prospecto {
    id
    fechaCreacion
    nombre
    apellidos
    telefono
    prefijo
    correo
    estado
    municipio
    ocupacion
    nombreComercial
    cultivoTipo
    comentarios
    calificacion
    eventoId
    evento {
      id
      nombre
    }
    universidad
    otraOcupacion
    carrera
    redSocial
    listaCultivos {
      cultivo {
        id
        nombre
      }
    }
    atendidoPor {
      id
      persona {
        id
        nombre
        apellidoPaterno
        apellidoMaterno
      }
    }
    numeroHA
    numeroSucursales
    numeroVendedores
    zona
  }
`;

export const OBTENER_PAGINADO_PROSPECTO = gql`
  query ProspectosPage(
    $query: QueryInput!
    $origen: String
    $ocupacion: String
    $estado: String
    $municipio: String
    $cultivoTipo: String
    $vendedorId: ID
    $zona: String
    $calificacion: String
    $distribuidorId: ID
  ) {
    prospectos {
      obtenerPaginado(
        query: $query
        origen: $origen
        ocupacion: $ocupacion
        estado: $estado
        municipio: $municipio
        cultivoTipo: $cultivoTipo
        vendedorId: $vendedorId
        zona: $zona
        calificacion: $calificacion
        distribuidorId: $distribuidorId
      ) {
        totalItems
        items {
          ...ProspectoFragment
          evento {
            nombre
          }
          numeroSucursales
          distribuidor{
            id
            distribuidor{
              id
              razonSocialFiscal
            }
            distribuidorId
          }
          tipoCliente
        }
      }
    }
  }
  ${PROSPECTO_FRAGMENT}
`;

export const OBTENER_OPCIONES = gql`
  query ProspectosPage($prospectoId: ID!) {
    prospectos {
      obtenerOpcionesSeguimiento(prospectoId: $prospectoId) {
        tieneDesarrollos
        tieneCotizaciones
        tieneOrdenesVentas
      }
    }
  }
`;

export const OBTENER_DISTRIBUIDORES = gql`
  query ObtenerDistribuidores {
    prospectos {
      obtenerDistribuidores {
        id
        razonSocialFiscal
      }
    }
  }
`;

export const OBTENER_PROSPECTO_PORID = gql`
  query ObtenerPorIdAsync($id: ID!) {
    prospectos {
      obtenerPorId(id: $id) {
        id
        nombre
        apellidos
        telefono
        correo
        tipoCliente
        direccionFiscal {
          id
          direccionTipo
          comentarios
          direccion {
            id
            codigoPostal
            numeroExterior
            numeroInterior
            calle
            colonia
            municipio
            estado
          }
        }
        atendidoPorId
      }
    }
  }
`;

export const OBTENER_CORREOS_CONTACTOS = gql`
  query ($prospectoId: ID!) {
    prospectos {
      obtenerCorreosContactos(prospectoId: $prospectoId)
    }
  }
`;

export const OBTENER_NOMBRES_CONTACTOS = gql`
  query ($prospectoId: ID!) {
    prospectos {
      obtenerNombreContactos(prospectoId: $prospectoId)
    }
  }
`;


export const OBTENER_PROSPECTO_PORID_NOTIFICACIONES = gql`
  query ObtenerProspectoPorIdNotificaciones($id: ID!) {
    prospectos {
      obtenerProspectoPorIdNotificaciones(id: $id) {
        id
        fechaCreacion
        nombre
        apellidos
        telefono
        prefijo
        correo
        estado
        municipio
        ocupacion
        nombreComercial
        cultivoTipo
        comentarios
        calificacion
        eventoId
        evento {
          id
          nombre
        }
        universidad
        otraOcupacion
        carrera
        redSocial
        listaCultivos {
          cultivo {
            id
            nombre
          }
        }
        atendidoPor {
          id
          persona {
            id
            nombre
            apellidoPaterno
            apellidoMaterno
          }
        }
        numeroHA
        numeroSucursales
        numeroVendedores
        zona
      }
    }
  }
`;